export const smsStatus = {
    methods: {
        smsStatusClass (sms) {
            if (!sms) {
                return ''
            }
            if (Number(sms.direction) === 0) {
                return 'sms-status-incoming'
            }
            switch (Number(sms.status)) {
            case -1:
                return 'sms-status-failed'
            case 0:
                return 'sms-status-pending'
            case 1:
            case 2:
                return 'sms-status-sent'
            default:
                return 'sms-status-pending'
            }
        },
        smsStatusLabel (sms) {
            if (!sms || Number(sms.direction) === 0) {
                return ''
            }
            switch (Number(sms.status)) {
            case -1:
                return this.$tc('words.failed')
            case 0:
                return this.$tc('words.pending')
            case 1:
            case 2:
                return this.$tc('words.sent')
            default:
                return this.$tc('words.pending')
            }
        },
        canResendSms (sms) {
            return sms && Number(sms.direction) !== 0 && Number(sms.status) === -1
        }
    }
}
